import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

import { GET_TICKET_UPGRADE_INFORMATION } from 'store/queries';
import { getTicketUpgradePricesParams, getUpgradeJourneysFromLegs, getUpgradeQuote } from 'utils/upgradePoints';

export const useUpgradeQuote = (booking) => {
  const request = useMemo(() => {
    if (!booking) {
      return {};
    }

    const journeys = getUpgradeJourneysFromLegs(booking.pendingCreationLegs || []);

    try {
      return { journeys, variables: getTicketUpgradePricesParams(journeys) };
    } catch (error) {
      return { error };
    }
  }, [booking]);

  const {
    data,
    loading,
    error: pricesError
  } = useQuery(GET_TICKET_UPGRADE_INFORMATION, {
    variables: request.variables,
    skip: !request.variables,
    fetchPolicy: 'network-only'
  });

  const pricing = useMemo(() => {
    if (!data) {
      return {};
    }

    try {
      return { quote: getUpgradeQuote(request.journeys, data.getTicketUpgradeInformation) };
    } catch (error) {
      return { error };
    }
  }, [data, request.journeys]);

  return {
    quote: pricing.quote ?? null,
    error: request.error || pricesError || pricing.error || null,
    loading
  };
};
